import React from 'react'
import { motion } from 'framer-motion';
import servicebg from '../../images/testimonial-bg.png';

function Faq() {
    const faqColumn1 = [
        {
            question: "Why choose Peregrinee over other software product development companies?",
            answer:
                "Peregrinee stands out because we focus on giving you results. We offer full transparency, personalized plans, and a team committed to delivering high-quality, scalable solutions.",
        },
        {
            question: "How does Peregrinee handle customer support after the project delivered?",
            answer: "We don’t just walk away after delivery. Our dedicated support team is always available to address any issues or provide enhancements as your business needs change. We’re here for the long haul to ensure your software continues to serve you effectively."
        },
        {
            question: "Which industries does Peregrinee work with?",
            answer: "We offer custom software development for businesses of all sizes across all industries. Our expertise covers IT, eCommerce, real estate, healthcare, finance, education, and more. Whatever your domain, we build tailored digital solutions to fuel your growth."
        },
        {
            question: "What are the benefits of outsourcing a software development company?",
            answer: "Outsourcing software product development lets you focus on core business functions while we handle the technical aspects. It's cost-effective and allows you access to specialized talent and resources without the overhead."
        },
        {
            question: "How much does a software development service could cost?",
            answer: "Pricing for a software development service is determined based on the duration of the engagement, the number of developers and other resources required, and the specific expertise needed. During the Discovery Meeting, we will discuss your project requirements in detail and provide a customized pricing structure tailored to your needs."
        },
        {
            question: "Do you offer ongoing support once we go live?",
            answer: "Yes, absolutely. At Peregrinee, we believe our job doesn’t end at delivery. We offer comprehensive post-launch maintenance and support to ensure your software continues to run smoothly and efficiently. Whether it's fixing bugs, implementing updates, or scaling features as your business grows, our team is here to support you every step of the way."
        },
        {
            question: "How do you communicate with your clients?",
            answer: "As the best software development company, we ensure effective communication with our clients and give them the flexibility to connect with our software development experts via Skype, Google Meet, and other preferred channels."
        }
    ];

    const faqColumn2 = [
        {
            question: "What technologies does Peregrinee use for custom software development?",
            answer:
                "Peregrinee utilizes a diverse tech stack, including React, Angular, Node.js, Python, Java, .NET, Flutter, React Native, AWS, Azure, and AI/ML frameworks like TensorFlow and PyTorch for cutting-edge, scalable software solutions.",
        },
        {
            question: "What is the software product development process and what are the steps?",
            answer:
                "Our software product development process involves initial consultation, planning, design, development, testing, and deployment. We follow an agile approach, ensuring each stage is aligned with your vision and business needs.",
        },
        {
            question: "How does Peregrinee ensure timely delivery of custom software projects?",
            answer:
                "With a structured project management approach, clear milestones, and a dedicated team, we ensure that projects are completed on time and to the highest standards. Our focus on efficiency and transparency means you’ll always know where your project stands.",
        },
        {
            question: "What types of custom software services does Peregrinee provide?",
            answer:
                "Peregrinee provides a wide range of custom software services such as enterprise solutions, SaaS platforms, mobile and web applications, AI-powered tools, MVPs, and automation systems tailored to specific business needs.",
        },
        {
            question: "Will we have a dedicated project manager?",
            answer:
                "Yes! At Peregrinee, we ensure you have a single point of contact throughout your project. Unlike other agencies, where clients are often passed between multiple team members, we assign a dedicated project manager from the moment the project kicks off until its completion, and even beyond if you choose to opt into a monthly retainer package after your go-live date.",
        },
        {
            question: "How do you ensure the confidentiality of my project?",
            answer:
                "Being the best software development company, we ensure end-to-end confidentiality of your project by signing a non-disclosure agreement (NDA) and implementing robust data encryption and security techniques.",
        },
        {
            question: "Do you work in my preferred time zone?",
            answer:
                "Yes. Being the best software development company, we have dedicated developers who work according to your preferred time zone to offer the best software development services.",
        }
        // Add more FAQ items here for column 2 if needed
    ];

     const fadeInUp = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
    };

    return (
        <section id="faq" className="faq-section" style={{ backgroundImage: `url(${servicebg})` }}>
            <motion.section className="container my-5"
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true, amount: 0.6 }}
                transition={{ duration: 0.8, ease: "easeOut" }}>
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div
                        className="px-3 fw-bold responsive-heading"
                    >
                        Frequently    <span className="highlight-orange">Asked </span>Questions
                    </div>
                </div>
                {/* <div className="d-flex justify-content-center mt-4">
                        <a
                            href="#contact-us"
                            className="btn custom-orange-btn py-3 px-4 fw-bold"
                        >
                            Book a Free Consultation
                        </a>
                    </div> */}
            </motion.section>
            <div className="container my-5">
                <div className="row g-4">
                    {/* Column 1 */}
                    <div className="col-12 col-md-6">
                        <div className="accordion" id="accordionColumn1">
                            {faqColumn1.map((faq, index) => (
                                <motion.div variants={fadeInUp}
                                        initial="hidden"
                                        whileInView="visible"
                                        viewport={{ once: false, amount: 0.3 }}
                                         className="accordion-item shadow mb-3 rounded p-2"
                                    key={index}
                                    style={{ boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}
                                >
                                    <h2 className="accordion-header" id={`heading1-${index}`}>
                                        <button
                                            className="accordion-button collapsed fw-bold"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#collapse1-${index}`}
                                            aria-expanded="true"
                                            aria-controls={`collapse1-${index}`}
                                            style={{
                                                fontWeight: '700',
                                                backgroundColor: '#fff',
                                                whiteSpace: 'normal',
                                                wordBreak: 'break-word',
                                                overflowWrap: 'break-word',
                                            }}
                                        >
                                            {faq.question}
                                        </button>
                                    </h2>
                                    <div
                                        id={`collapse1-${index}`}
                                        className="accordion-collapse collapse"
                                        aria-labelledby={`heading1-${index}`}
                                        data-bs-parent="#accordionColumn1"
                                    >
                                        <div
                                            className="accordion-body"
                                            style={{ backgroundColor: '#fff4e6' }}
                                        >
                                            {faq.answer}
                                        </div>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>

                    {/* Column 2 */}
                    <div className="col-12 col-md-6">
                        <div className="accordion" id="accordionColumn2">
                            {faqColumn2.map((faq, index) => (
                                <motion.div 
                                variants={fadeInUp}
                                        initial="hidden"
                                        whileInView="visible"
                                        viewport={{ once: false, amount: 0.3 }}
                                        className="accordion-item shadow mb-3 rounded p-2"
                                    key={index}
                                    style={{ boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}
                                >
                                    <h2 className="accordion-header" id={`heading2-${index}`}>
                                        <button
                                            className="accordion-button collapsed fw-bold"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#collapse2-${index}`}
                                            aria-expanded="true"
                                            aria-controls={`collapse2-${index}`}
                                            style={{
                                                fontWeight: '700',
                                                backgroundColor: '#fff',
                                                whiteSpace: 'normal',
                                                wordBreak: 'break-word',
                                                overflowWrap: 'break-word',
                                            }}
                                        >
                                            {faq.question}
                                        </button>
                                    </h2>
                                    <div
                                        id={`collapse2-${index}`}
                                        className="accordion-collapse collapse"
                                        aria-labelledby={`heading2-${index}`}
                                        data-bs-parent="#accordionColumn2"
                                    >
                                        <div
                                            className="accordion-body"
                                            style={{ backgroundColor: '#fff4e6' }}
                                        >
                                            {faq.answer}
                                        </div>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Faq